interface Html2PdfOutput {
  output: (type: 'bloburl') => string
}

interface Html2PdfOptions {
  margin: [number, number]
  filename: string
  image: {
    type: 'jpeg'
    quality: number
  }
  pagebreak: {
    mode: 'legacy'
  }
  html2canvas: {
    scale: number
    width: number
    windowWidth: number
    x: number
    allowTaint: boolean
    useCORS: boolean
  }
  jsPDF: {
    unit: 'mm'
    format: 'a4'
    orientation: 'portrait'
  }
}

interface Html2PdfBuilder {
  from: (element: HTMLElement) => Html2PdfBuilder
  set: (options: Html2PdfOptions) => Html2PdfBuilder
  toPdf: () => Html2PdfBuilder
  get: (key: 'pdf') => Promise<Html2PdfOutput>
}

export function exportSimulationPdf(args: {
  html2pdf: () => unknown
  locale: string
  amount: number
  simulationTitle: string
  simulationLabel: string
}) {
  const element = document.getElementById('print') as HTMLElement
  if (!element) return

  const html2PdfOptions: Html2PdfOptions = {
    margin: [0, 0],
    filename: 'simulation.pdf',
    image: { type: 'jpeg', quality: 1 },
    pagebreak: { mode: 'legacy' },
    html2canvas: {
      scale: 3,
      width: 1000,
      windowWidth: 5000,
      x: -100,
      allowTaint: true,
      useCORS: true,
    },
    jsPDF: {
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait',
    },
  }

  const pdfBuilder = args.html2pdf() as Html2PdfBuilder

  pdfBuilder
    .from(element)
    .set(html2PdfOptions)
    .toPdf()
    .get('pdf')
    .then((pdf: Html2PdfOutput) => {
      const parseAmount = new Intl.NumberFormat(args.locale, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
      })
      const pdfName = `Portfolio Stock Exchange ${args.simulationLabel} ${args.simulationTitle} ${parseAmount.format(args.amount)}`
      downloadPdf(pdf.output('bloburl'), pdfName)
    })
}

function sanitizeFileName(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[/\\?%*:|"<>.,-]/g, '_')
    .replace(/\s+/g, '_')
}

function downloadPdf(pdfUrl: string, pdfFileName: string) {
  const link = document.createElement('a')
  link.href = pdfUrl
  link.target = '_blank'
  link.download = `${sanitizeFileName(pdfFileName)}.pdf`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
